// extracted by css-extract-rspack-plugin
export default {"divider":"divider__TXHTX","termBox":"termBox__ZQu4e","submitBox":"submitBox__RCJ8d"};